export default {
  includeInverseLogo: true,
  backgroundColour: 'brandOne100',
  linkColour: 'brandOne20',
  linkHoverDecoration: 'none',
  linkDividerColor: 'brandOne80',
  smallTextColor: 'brandOne20',
  seperateLinkBar: false,
};
